import cx from 'classnames';
import { forwardRef } from 'react';
import { StyledPaper } from './style';

interface PaperProps {
  className?: string;
  width?: number;
  height?: number;
  elevation?: number;
  color?: string;
  children?: React.ReactNode;
}

const Paper = forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
  const {
    children, className, width = 300, height = 200, elevation = 0, color = '#FFFFFF', ...other
  } = props;
  return (
    <StyledPaper
      className={cx('paper', className)}
      width={width}
      height={height}
      elevation={elevation}
      color={color}
      ref={ref}
      {...other}
    >
      {children}
    </StyledPaper>
  );
});

export default Paper;
